import { Skeleton } from 'antd'

interface Props {
  isLoading: boolean
  children: React.ReactNode
  rows?: number
}

const Loading = ({ isLoading, children, rows = 2 }: Props) => {
  return (
    <>
      {isLoading ? (
        <div className='w-full p-10'>
          <Skeleton active={true} className='p-2' paragraph={{ rows }} />
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  )
}

export default Loading
